<template>
    <div class="renderCont">
      <div class="topInfo">
        <div class="hamburger" @click="handleOpen(true)"></div>
        <div class="sbCont">
          <input type="text" class="searchbar" placeholder="Buscar" v-model="search">
          <p></p>
        </div>
        <LoginButton class="loginButton"/>
      </div>
      <div class="routerCont">
        <div v-if="artists?.length>0 || tracks?.length>0">
          <results-view :artists="artists" :tracks="tracks"/>
        </div>
        <div v-else>
          <router-view/>
        </div>
      </div>
    </div>
</template>

<script>
import LoginButton from '@/components/LoginButton.vue'
import ResultsView from '@/views/ResultsView.vue'
export default {
    components:{
      LoginButton,
      ResultsView
    },
    props:{
      handleOpen: Function
    },
    data(){
      return{
        search: '',
        artists: [],
        tracks: [],
      }
    },
    methods:{     
      togglePlay(){
        if(this.playing){
          this.$refs.audioPlayer.pause();
        } else {
          this.$refs.audioPlayer.play();
        }
        this.playing = !this.playing
      },
      toggleAudio(){
        this.muted = !this.muted
        this.$refs.audioPlayer.muted=this.muted
      },
      localWatcher(){
        setInterval(()=>{
          if(localStorage.getItem('currentSong') && this.currentSong.id!=JSON.parse(localStorage.getItem('currentSong')).id){
            this.currentSong=JSON.parse(localStorage.getItem('currentSong'))
          }
        }, 500)
      },
    },
    watch:{
      search(){
        const arturl= this.baseUrl + '/search/artist/?q='+this.search+'&index=0&limit=10&output=json'
        const trackurl= this.baseUrl + '/search/track/?q='+this.search+'&index=0&limit=10&output=json'
        fetch(arturl)
          .then(response=>response.json())
          .then(json=>this.artists = json.data);
        fetch(trackurl)
          .then(response=>response.json())
          .then(json=>this.tracks = json.data);
      }
    },
    created(){
      if(typeof localStorage.getItem('currentSong') !== 'undefined'){
        this.currentSong=JSON.parse(localStorage.getItem('currentSong'))
      }
    },
    beforeMount(){
      this.localWatcher()
    },    
}
</script>

<style scoped>

.renderCont{
  width: 100%;
  margin-left: 370px;
}

.routerCont{
  margin: 20px 40px;
  padding-bottom: 120px;
}

.topInfo{
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  margin-bottom: 15px;
}

.searchbar{
  border: 1px solid #828282;
  border-radius: 10px;
  height: 25px;
  width: 0;
  padding-left: 10px;
  min-width: 100%;
}

.sbCont{
  position: relative;
  min-width: 50px;
  width: 100%;
}

.sbCont>p{
  font-family: 'Font Awesome 6 Free';
  font-weight: 700;
  position: absolute;
  margin: 0;
  right: 10px;
  top: 7px
}

.logout{
  color: white;
  background-color: var(--mainred);
  height: 35px;
  width: fit-content;
  padding: 0 15px;
  border: 0px;
  border-radius: 18px;
  cursor: pointer;
}

.hamburger{
  display: none;
}
.loginButton{
  padding: 0 20px;
}

@media screen
 and (max-width:880px){
    .hamburger{
      display: block;
      position: relative;
      font-family: 'Font Awesome 6 Free';
      font-weight: 600;
      font-size: 24px;
      margin: 0 10px 0 20px;
      height: max-content;
    }
    .renderCont{
      margin-left: 0;
    }
    .topInfo{
      padding: 20px 0 0 0;
    }
    .loginButton{
      flex-basis: 150px;
    }
    .sbCont{
      margin: 0 10px;
      flex-basis: 50%;
      flex-grow: 0;
    }
}
</style>